import React from 'react';
import Select from 'react-select';

const CustomSelectFilter = ({ column: { filterValue, setFilter }, options }) => {
  const handleChange = selectedOption => {
    setFilter(selectedOption ? selectedOption.value : undefined);
  };

  // Map filterValue to its corresponding label
  const selectedOption = options.find(option => option.value === filterValue) || { value: undefined, label: 'None' };

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={[
        { value: undefined, label: 'None' }, // Add None option
        ...options
      ]}
      className="react-select-container"
      classNamePrefix="react-select"
      isSearchable  // Enable search functionality
    />
  );
};

export default CustomSelectFilter;
